import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { SetEntornoEmp } from "../redux/store/Actions";
import { motion } from "framer-motion";
import { FaBuilding, FaUserTie, FaHandshake } from "react-icons/fa";
const logo = require("../Login/digitalProf-it.png");

interface Acceso {
  id: number;
  id_client: number;
  id_profile: number;
  profile: string;
  client_name: string;
  idbusiness_group: number;
}

const SeleccionarPanel: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, token, accesos } = location.state as {
    user: any;
    token: string;
    accesos: Acceso[];
  };

  useEffect(() => {
    document.body.style.background = "linear-gradient(160deg, #0a0a0a 0%, #1a1a1a 40%, #2d2d2d 70%, #404040 100%)";
    document.body.style.minHeight = "100vh";
    document.body.style.margin = "0";
    return () => {
      document.body.style.background = "";
      document.body.style.minHeight = "";
      document.body.style.margin = "";
    };
  }, []);

  const seleccionar = (acceso: Acceso) => {
    const userPayload = {
      first_name: user.first_name,
      id_user: user.id_user,
      last_name: user.last_name,
      profile: acceso.profile,
      token: token,
      user: user.user_email,
      idbusiness_group: acceso.idbusiness_group,
      id_client: acceso.id_client,
      client_name: acceso.client_name,
    };

    dispatch(SetEntornoEmp(userPayload));
    localStorage.setItem("user", JSON.stringify({ user, token, accesos }));
    localStorage.setItem("authToken", token);
    localStorage.setItem("userData", JSON.stringify(userPayload));
    navigate("/home");
  };

  const iconoPerfil = (profile: string) => {
    if (profile === "Administrador") return <FaUserTie size={28} />;
    if (profile === "Evaluador") return <FaHandshake size={28} />;
    return <FaBuilding size={28} />;
  };

  const colorPerfil = (profile: string) => {
    if (profile === "Administrador") return "#1a3a5c";
    if (profile === "Evaluador") return "#27ae60";
    return "#7f8c8d";
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", overflow: "auto" }}>

      {/* Header Deep Blue */}
      <div style={{
        backgroundColor: "#151D20",
        padding: "14px 32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexShrink: 0,
      }}>
        <img src={logo} alt="Logo" style={{ maxHeight: "32px", filter: "brightness(0) invert(1)" }} />
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: "10px", color: "#9BDD33", letterSpacing: "0.1em", textTransform: "uppercase" }}>
            Bienvenido
          </div>
          <div style={{ color: "#ffffff", fontWeight: "bold", fontSize: "14px" }}>
            {user.first_name} {user.last_name}
          </div>
        </div>
      </div>

      {/* Área exterior con degradado — contiene la tarjeta blanca */}
      <div style={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
      }}>
        {/* Tarjeta blanca central */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.35)",
            padding: "40px 36px",
            maxWidth: "620px",
            width: "100%",
            textAlign: "center",
          }}
        >
          <p style={{ color: "#888", fontSize: "0.82rem", marginBottom: "6px", letterSpacing: "0.08em", textTransform: "uppercase" }}>
            Bienvenido, {user.first_name}
          </p>
          <h2 style={{ color: "#151D20", fontWeight: "900", fontSize: "1.8rem", marginBottom: "4px" }}>
            Selecciona tu perfil
          </h2>
          <p style={{ color: "#aaa", fontSize: "0.85rem", marginBottom: "32px" }}>
            Elige el módulo al que deseas acceder
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            {accesos
              .filter((acceso) => acceso.profile !== "Colaborador")
              .map((acceso) => (
              <motion.button
                key={acceso.id}
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => seleccionar(acceso)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "18px",
                  padding: "18px 24px",
                  border: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(135deg, #151D20 0%, #2e3f4f 60%, #4a5568 100%)",
                  cursor: "pointer",
                  textAlign: "left",
                  transition: "filter 0.2s",
                  width: "100%",
                  boxShadow: "0 2px 10px rgba(21,29,32,0.2)",
                }}
                onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                  e.currentTarget.style.filter = "brightness(1.2)";
                }}
                onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                  e.currentTarget.style.filter = "brightness(1)";
                }}
              >
                <div style={{
                  backgroundColor: "#9BDD3325",
                  color: "#9BDD33",
                  borderRadius: "8px",
                  width: "44px",
                  height: "44px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}>
                  {iconoPerfil(acceso.profile)}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "800", color: "#ffffff", fontSize: "15px" }}>
                    {acceso.profile}
                  </div>
                  {acceso.profile !== "Administrador" && (
                    <div style={{ color: "#aaa", fontSize: "12px", marginTop: "2px" }}>
                      {acceso.client_name}
                    </div>
                  )}
                </div>
                <div style={{ color: "#9BDD33", fontSize: "22px", fontWeight: "bold" }}>›</div>
              </motion.button>
            ))}
          </div>
        </motion.div>
      </div>

      {/* Footer Deep Blue */}
      <footer style={{
        backgroundColor: "#151D20",
        textAlign: "center",
        padding: "16px",
        color: "#ffffff",
        fontSize: "12px",
        flexShrink: 0,
      }}>
        © DIGITAL PROFIT SAS COLOMBIA {new Date().getFullYear()}
      </footer>
    </div>
  );
};

export default SeleccionarPanel;